import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  AccordionWrapper,
  StyledAccordion,
  AccordionHeader,
  AccordionBtn,
  AccordionBody,
} from './styles';

// * className {string} A string used to style the accordion wrapper
// * children {array} Array of React elements

const Accordions = ({ sectionId, className, children, onChange }) => {
  return (
    <AccordionWrapper
      id={sectionId}
      className={className}
      onChange={onChange}
      allowZeroExpanded
    >
      {children}
    </AccordionWrapper>
  );
};

// * className {string} A string used to style each accordion
// * children {array} The contents of the accordion body
// * title {string} The text to be displayed in the button
// * richText {RichText} The text to be displayed in the button if the text is richText

const Accordion = ({ uuid, className, children, title, html }) => {
  return (
    <StyledAccordion id={uuid} uuid={uuid} className={className}>
      <AccordionHeader>
        <AccordionBtn>{title || ReactHtmlParser(html)}</AccordionBtn>
      </AccordionHeader>
      <AccordionBody>{children}</AccordionBody>
    </StyledAccordion>
  );
};

Accordions.propTypes = {
  className: PropTypes.string,
  sectionId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  onChange: PropTypes.func,
};

Accordions.defaultProps = {
  className: null,
  sectionId: null,
  onChange: () => {},
};

Accordion.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  title: PropTypes.string,
  uuid: PropTypes.string,
  html: PropTypes.string,
};

Accordion.defaultProps = {
  className: null,
  title: null,
  html: null,
  uuid: null,
};

export { Accordions, Accordion };
